import {
  Body1,
  Button,
  Dialog,
  Textarea,
  Subtitle1,
  DialogSurface,
  DialogOpenChangeEvent,
  DialogOpenChangeData,
  Checkbox,
  Caption1,
} from '@fluentui/react-components';
import * as React from 'react';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { useChatBladeStyles } from './CareerCopilotChat.styles';
import { ResponseFeedback, ResponseCategories } from '@careerhub/api';
import { CareerHubModuleReactContext } from '@careerhub/common';

interface ICopilotFeedbackFormProps {
  isOpen: boolean;
  responseFeedback: ResponseFeedback;
  handleSubmitTaskModule: (commentResponse: string, responseCategories: ResponseCategories[]) => void;
  handleOpenCloseTaskModule: (isOpen: boolean) => void;
}

export const CopilotFeedbackForm = (props: ICopilotFeedbackFormProps) => {
  const styles = useChatBladeStyles();
  const { telemetryClient } = React.useContext(CareerHubModuleReactContext);
  const { handleOpenCloseTaskModule, handleSubmitTaskModule, responseFeedback } = props;
  const [isOpen, setIsOpen] = React.useState(props.isOpen);
  const [feedback, setFeedback] = React.useState('');
  const [option1, setOption1] = React.useState(false);
  const [option2, setOption2] = React.useState(false);
  const [option3, setOption3] = React.useState(false);
  const [option4, setOption4] = React.useState(false);
  const [option5, setOption5] = React.useState(false);

  const handleSubmit = () => {
    const responseCategories = handleResponseCategory();
    telemetryClient.logButtonClick('Copilot', 'CopilotFeedbackFormSubmit', {});
    handleSubmitTaskModule(feedback, responseCategories);
  };

  const handleDialog = (_event: DialogOpenChangeEvent, data: DialogOpenChangeData) => {
    setIsOpen(data.open);
    handleOpenCloseTaskModule(data.open);
  };

  const handleResponseCategory = (): ResponseCategories[] => {
    let categories: ResponseCategories[] = [];
    if (option1) categories.push(ResponseCategories.DepthOfInformation);
    if (option2) categories.push(ResponseCategories.UsefulnessOfInformation);
    if (option3) categories.push(ResponseCategories.AccuracyOfInformation);
    if (option4) categories.push(ResponseCategories.TrustworthinessOfInformation);
    if (option5) categories.push(ResponseCategories.Other);
    return categories;
  };
  return (
    <Dialog onOpenChange={handleDialog} modalType="modal" open={isOpen}>
      <DialogSurface className={styles.surfaceContainer} aria-label="Tell us more">
        <div className={styles.feedbackContainer}>
          <div className={styles.dismissButtonContainer}>
            <Subtitle1 as="h2">Tell us more</Subtitle1>
            <Button
              appearance="transparent"
              icon={<Dismiss24Regular />}
              onClick={() => {
                telemetryClient.logButtonClick('Copilot', 'CopilotFeedbackFormDismiss', {});
                setIsOpen(false);
                handleOpenCloseTaskModule(false);
              }}
              title="Close"
            />
          </div>
          {responseFeedback === ResponseFeedback.ThumbsUp ? (
            <Body1>What did you like?</Body1>
          ) : (
            <>
              <Body1>I am not satisfied with</Body1>
              <div className={styles.checkboxContainer}>
                <Checkbox
                  checked={option1}
                  onChange={() => setOption1((checked) => !checked)}
                  label="Depth of information"
                  aria-label="I am not satisfied with Depth of information 1 of 5"
                />
                <Checkbox
                  checked={option2}
                  onChange={() => setOption2((checked) => !checked)}
                  label="Usefulness of information"
                  aria-label="I am not satisfied with Usefulness of information 2 of 5"
                />
                <Checkbox
                  checked={option3}
                  onChange={() => setOption3((checked) => !checked)}
                  label="Accuracy of information"
                  aria-label="I am not satisfied with Accuracy of information 3 of 5"
                />
                <Checkbox
                  checked={option4}
                  onChange={() => setOption4((checked) => !checked)}
                  label="Trustworthiness of information (no citations were provided)"
                  aria-label="I am not satisfied with Trustworthiness of information (no citations were provided) 4 of 5"
                />
                <Checkbox
                  checked={option5}
                  onChange={() => setOption5((checked) => !checked)}
                  label="Other"
                  aria-label="I am not satisfied with Other 5 of 5"
                />
              </div>
              <Body1>What went wrong?</Body1>
            </>
          )}
          <Textarea
            value={feedback}
            onChange={(e, data) => {
              console.log(e);
              setFeedback(data.value);
            }}
            title={responseFeedback === ResponseFeedback.ThumbsUp ? 'What did you like' : 'What went wrong'}
            placeholder="Provide details without including personal information"
            className={styles.feedbackTextBox}
          />
          <Caption1 className={styles.feedbackFineText}>
            By pressing Submit, your feedback will be used to improve Microsoft products and services. IT admins for
            your organization will be able to view and manage your feedback data.
            <a href="https://privacy.microsoft.com/en-US/data-privacy-notice" target="_blank" rel="noopener noreferrer">
              Privacy statement
            </a>
          </Caption1>
          <div className={styles.feedbackButtonContainer}>
            <Button appearance="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button
              onClick={() => {
                telemetryClient.logButtonClick('Copilot', 'CopilotFeedbackFormDismiss', {});
                setIsOpen(false);
                handleOpenCloseTaskModule(false);
              }}
            >
              Dismiss
            </Button>
          </div>
        </div>
      </DialogSurface>
    </Dialog>
  );
};
